import { Siren, PersonStanding, AudioLines, BedDouble, Router, WifiOff, Bell, Flame, TriangleAlert, Info, ShieldOff, Wind, BatteryWarning } from "lucide-react";

export const TIPO_META = {
  boton_panico: { label: "Botón de ayuda activado", Icon: Siren },
  caida: { label: "Caída", Icon: PersonStanding },
  excepcion_audio: { label: "Excepción de audio", Icon: AudioLines },
  fuera_de_cama_nocturno_sin_retorno: { label: "Fuera de cama nocturno", Icon: BedDouble },
  fuera_de_cama: { label: "Fuera de cama", Icon: BedDouble },
  retorno_cama: { label: "Retorno a cama", Icon: BedDouble },
  salida_bano_sin_retorno: { label: "Salida de baño sin retorno", Icon: PersonStanding },
  fuera_de_zona_permitida: { label: "Fuera de zona permitida", Icon: PersonStanding },
  permanencia_prolongada_zona: { label: "Permanencia prolongada", Icon: PersonStanding },
  // R8 · catálogo completo del radar VS373 (Milesight). Etiquetas FACTUALES: dicen lo que el
  // sensor reportó, sin diagnóstico ni términos clínicos.
  inmovilidad_prolongada: { label: "Inmovilidad prolongada", Icon: PersonStanding },
  persona_en_piso_prolongado: { label: "Persona en el piso", Icon: PersonStanding },
  frecuencia_respiratoria_baja: { label: "Frecuencia respiratoria baja", Icon: Wind },
  frecuencia_respiratoria_alta: { label: "Frecuencia respiratoria alta", Icon: Wind },
  vs373_ocupacion: { label: "Ocupación del radar", Icon: Info },
  informativo: { label: "Informativo", Icon: Info },
  recordatorio_programado: { label: "Recordatorio programado", Icon: Bell },
  puente_silencioso: { label: "Puente silencioso", Icon: Router },
  ws101_procesamiento: { label: "Entrega WS101 pendiente de verificación técnica", Icon: WifiOff },
  dispositivo_silencioso: { label: "Dispositivo silencioso", Icon: WifiOff },
  cobertura_perdida: { label: "Cobertura crítica perdida", Icon: ShieldOff },
  // MOKO-BAT-01 · hecho del EQUIPO: el botón reporta su propia carga. No es una condición de la persona.
  bateria_baja: { label: "Batería baja del botón de ayuda", Icon: BatteryWarning },
};

export const CAPACIDAD_LABEL = { caida: "caída", panico: "botón de ayuda", presencia: "presencia", audio: "audio", cama: "cama" };
export const TIPOS_TECNICOS = new Set(["ws101_procesamiento", "puente_silencioso", "dispositivo_silencioso", "cobertura_perdida", "bateria_baja"]);

export const tipoMeta = (t) => TIPO_META[t] || { label: t || "Alarma", Icon: Bell };

export const PRIORIDAD_LABEL = { alta: "Alta", media: "Media", baja: "Baja" };

// Eje PRIORIDAD (qué tan urgente). Color NUNCA solo: siempre texto + ícono.
// ALTA=rojo, MEDIA=ámbar, BAJA=cian discreto. (Se eliminó el nivel 'maxima' azul.)
export const PRIORIDAD_META = {
  alta: { label: "Alta", Icon: Flame, badge: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300", text: "text-red-600 dark:text-red-400" },
  media: { label: "Media", Icon: TriangleAlert, badge: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300", text: "text-amber-600 dark:text-amber-400" },
  baja: { label: "Baja", Icon: Info, badge: "bg-cyan-100 text-cyan-800 dark:bg-cyan-900/40 dark:text-cyan-300", text: "text-cyan-700 dark:text-cyan-400" },
};
export const prioridadMeta = (p) => PRIORIDAD_META[p === "maxima" ? "alta" : p] || PRIORIDAD_META.media;

export const ESTADO_LABEL = {
  recibida: "Recibida",
  tomada: "Tomada",
  en_verificacion: "En verificación",
  no_verificable: "No verificable",
  escalada: "Escalada",
  cerrada: "Cerrada",
};

export const RESULTADOS = [
  { value: "emergencia_real", label: "Emergencia real" },
  { value: "falsa_alarma", label: "Falsa alarma" },
  { value: "sin_emergencia_confirmada", label: "Sin emergencia confirmada" },
  { value: "escalado_sin_confirmacion", label: "Escalado sin confirmación" },
  { value: "prueba_del_sistema", label: "Prueba del sistema" },
];

// TECH-001 — Catálogo de resolución de una INCIDENCIA TÉCNICA (espejo de lectura del catálogo
// autoritativo del backend, que viaja en detail.resoluciones_tecnicas). Sólo "Restablecido" y
// "Equipo reemplazado" cierran; el resto registra seguimiento y la incidencia sigue abierta.
export const RESOLUCIONES_TECNICAS = [
  { codigo: "restablecido", etiqueta: "Restablecido", terminal: true },
  { codigo: "energia_red", etiqueta: "Energía/red", terminal: false },
  { codigo: "equipo_reemplazado", etiqueta: "Equipo reemplazado", terminal: true },
  { codigo: "proveedor", etiqueta: "Proveedor", terminal: false },
  { codigo: "pendiente", etiqueta: "Pendiente", terminal: false },
];

export const RESULTADO_LABEL = {
  // TECH-001: resoluciones terminales de incidencia técnica.
  restablecido: "Restablecido",
  equipo_reemplazado: "Equipo reemplazado",
  emergencia_real: "Emergencia real",
  falsa_alarma: "Falsa alarma",
  sin_emergencia_confirmada: "Sin emergencia confirmada",
  escalado_sin_confirmacion: "Escalado sin confirmación",
  prueba_del_sistema: "Prueba del sistema",
  resuelto_por_recuperacion: "Resuelto por recuperación",
  // Terminales Día 1 (etiquetas de lectura; el catálogo autoritativo sigue en el backend).
  verificado_directamente: "Verificado directamente",
  verificado_contacto_autorizado: "Verificado por contacto autorizado",
  no_verificado_accion_final_cumplida: "No verificado — acción final cumplida",
  emergencia_handoff_completado: "Handoff a emergencias completado",
  resuelto_otra_via: "Resuelto por otra vía",
  no_verificado_sin_gestion: "Cerrado sin verificación (sin gestión registrada)",
  // v2.13.1 — recordatorio programado. Galarya sólo afirma que COMUNICÓ el recordatorio.
  recordatorio_comunicado: "Recordatorio comunicado",
  sin_contacto: "Sin contacto",
};

export const CAUSAS_FALSA = [
  { value: "mascota", label: "Mascota" },
  { value: "visita", label: "Visita" },
  { value: "sensor_mal_posicionado", label: "Sensor mal posicionado" },
  { value: "movimiento_normal_mal_clasificado", label: "Movimiento normal mal clasificado" },
  { value: "otro", label: "Otro" },
];

// Transiciones permitidas desde cada estado (para los botones de acción).
export const SIGUIENTES = {
  tomada: [["en_verificacion", "Iniciar verificación"]],
  en_verificacion: [["no_verificable", "Marcar no verificable"], ["escalada", "Escalar"]],
  no_verificable: [["escalada", "Escalar"]],
  escalada: [],
};

// Umbral (segundos) tras el cual una alarma "Recibida" se vuelve más notoria (pulso).
export const AGING_SEG = 120;

export function elapsed(fromIso, nowMs) {
  if (!fromIso) return "—";
  const start = new Date(fromIso).getTime();
  let s = Math.max(0, Math.floor((nowMs - start) / 1000));
  const h = Math.floor(s / 3600);
  s %= 3600;
  const m = Math.floor(s / 60);
  const ss = s % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(ss)}` : `${pad(m)}:${pad(ss)}`;
}

export function elapsedSeg(fromIso, nowMs) {
  if (!fromIso) return 0;
  return Math.max(0, Math.floor((nowMs - new Date(fromIso).getTime()) / 1000));
}
